import {
    AvailabilityFreshness,
    type ProviderProfileV2,
    UpcomingLittersRow,
} from "@/features/providers";
import { RecentlyAdoptedSection } from "../RecentlyAdoptedSection";
import type { ProviderDogListingCard } from "../provider-listing-card";
import { AvailablePuppiesSection } from "./AvailablePuppiesSection";
import { NothingListedSection } from "./NothingListedSection";

export function BreederListingsBlock({
    profile,
    summaryCards,
    adoptedCards,
    breederName,
    providerId,
    total,
    availableCount,
    fallbackImageUrl,
}: {
    profile: ProviderProfileV2 | null | undefined;
    summaryCards: ProviderDogListingCard[];
    adoptedCards: ProviderDogListingCard[];
    breederName: string;
    providerId: string;
    total: number;
    availableCount: number;
    fallbackImageUrl?: string;
}) {
    if (total === 0) {
        return (
            <NothingListedSection
                adoptedCards={adoptedCards}
                profile={profile}
            />
        );
    }
    const availability = profile && (
        <>
            <AvailabilityFreshness
                availability={profile.availability}
                listingCount={availableCount}
            />
            <UpcomingLittersRow
                litters={profile.availability.upcomingLitters}
                className="mt-3"
            />
        </>
    );
    return (
        <>
            <div className="mb-5 hidden md:block">
                <h2 className="text-section-title text-doberman-black text-balance">
                    Available puppies
                </h2>
                {availability && <div className="mt-2">{availability}</div>}
            </div>
            <AvailablePuppiesSection
                mobileDescription={availability}
                availablePuppyCards={summaryCards}
                breederName={breederName}
                providerId={providerId}
                totalPuppyCount={total}
                availableCount={availableCount}
                fallbackImageUrl={fallbackImageUrl}
            />
            <RecentlyAdoptedSection className="mt-12" cards={adoptedCards} />
        </>
    );
}
